<template>
  <div>
    <table v-if="rxObj">
      <tr>
        <td class="col1Min">
          <div class="overline">{{ dontVertex ? "Power" : "Refraction" }}</div>
          {{ prettyStringMinus(rxObj) }} <span class="caption">(minus cyl)</span
          ><br />
          {{ prettyStringPlus(rxObj) }}<span class="caption"> (plus cyl)</span>
        </td>
        <td>
          <div class="crossCell">
            <optical-cross-image
              :dimensions="55"
              :obj="rxObj"
              type="refraction"
            ></optical-cross-image>
          </div>
        </td>
      </tr>
      <tr v-if="!dontVertex">
        <td>
          <div class="overline">
            Vertexed ({{ rxObj.vertex * 1000 }}&rarr;0
            <span class="text-lowercase">mm</span>)
          </div>
          {{ prettyStringMinus(vertexedRxObj, 0.01) }}<br />
          {{ prettyStringFromString(sphericalEquivalent(vertexedRxObj), 0.01)
          }}<span class="caption"> (sph equiv)</span>
        </td>

        <td>
          <div class="crossCell">
            <optical-cross-image
              :dimensions="55"
              :obj="vertexedRxObj"
              type="refraction"
            ></optical-cross-image>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="overline">Nerdy Details</div>
          Cyl Type: {{ cylOrientationType(rxObj) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "RxInformation",
  components: {
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
  },
  mixins: [RxMethods, StyleUtilities],
  props: {
    rxObj: null,
    dontVertex: null,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    vertexedRxObj: function () {
      if (!this.rxObj) return null;
      let vRx = this.diffVertex(this.rxObj, 0, this.rxObj.vertex);
      vRx.round = 0.01;
      return vRx;
    },
  },
};
</script>

<style scoped>
.col1Min {
  min-width: 200px;
}
.crossCell {
  /* padding-top: 30px; */
  min-height: 120px;
}
</style>
